export function addIncomingCall(data){
    return dispatch => {
       return dispatch({
           type: 'ADD_INCOMING_CALL',
           payload: data
       });
    };
}

export function removeIncomingCall(data){
    return dispatch => {
       return dispatch({
           type: 'REMOVE_INCOMING_CALL',
           payload: data
       });
    };
}


// WEBPACK FOOTER //
// ./src/actions/incomingCallsList.js